<template>
  <div class="queue-location-list-item-container">
    <div class="item-text" :class="{ 'switch-all': isSwitchAll }">
      {{ location?.name }}
    </div>

    <CustomSwitch
      :model-value="location?.is_queueable"
      @change="$emit('change', location)"
    />
  </div>
</template>

<script>
import CustomSwitch from "@/v3components/shared/Form/CustomSwitch.vue"

export default {
  name: "LocationListItem",
  components: {
    CustomSwitch
  },
  props: {
    location: {
      type: Object,
      default: () => ({})
    },
    isSwitchAll: {
      type: Boolean,
      default: false
    }
  },
  emits: ["change"]
}
</script>
